import { useEffect } from 'react'

/**
 * Adds an external script from a given URL to the HTML `head` section.
 *
 * @param url Full URL of the external script.
 * @param elementId Unique HTML element `id` attribute for the script tag.
 */
export const useExternalScript = (url: string, elementId: string) => {
  useEffect(() => {
    let script: HTMLScriptElement = document.getElementById(
      elementId
    ) as HTMLScriptElement
    if (!script) {
      script = document.createElement('script')
      script.src = url
      script.id = elementId
      script.type = 'text/javascript'
      script.defer = true
      script.async = true
      document.head.appendChild(script)
    }
  }, [url, elementId])
}
